import SwaggerUI from 'swagger-ui-react';
import 'swagger-ui-react/swagger-ui.css';
import { Section } from '../components/Section';

const env = (typeof globalThis !== 'undefined' && (globalThis as any).__APP_ENV__) || {};
const swaggerUrl =
  (env.swaggerUrl as string) || '/swagger.yaml';

export default function Docs() {
  return (
    <Section title="Docs KPI" description="Swagger UI">
      <div className="min-h-[60vh] overflow-hidden rounded border">
        <SwaggerUI url={swaggerUrl} docExpansion="none" />
      </div>
    </Section>
  );
}
